import axios from './axios';

export const createSupportTicket = values =>
  axios({
    method: 'post',
    url: `/v1/salesforce/tickets`,
    data: values
  });
